<template>
  <section class="mianPage">
    <div>
      <img :src="mianpg" alt="" />
    </div>
  </section>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      mianpg: require("./assets/img/mainbg.png")
    };
  },
  watch: {},
  components: {},
  async mounted() {},
  methods: {},
  created() {}
};
</script>
<style lang="less" scope>
.mianPage {
  width: 100%;
  height: 100%;
  overflow: auto;
  img {
    width: 100%;
  }
}
</style>
